
export let pais=(valor)=>{ return {type:"PAIS",payload:valor} };
export let setTipoCambio=(valor)=>{ return {type:"TIPOCAMBIO",payload:valor} };